import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";

const SingleSelect = ({
    label,
    value,
    options,
    placeholder,
    onChange,
    getOptionLabel = (option) =>
        typeof option === "string" ? option : option.label,
    widthClass = "w-full",
}) => {
    return (
        <div className={widthClass}>
            {label && (
                <label className="block text-[14px] font-medium text-gray-700 mb-1">
                    {label}
                </label>
            )}
            <Autocomplete
                value={value || null}
                options={options}
                onChange={(e, newValue) => onChange(newValue)}
                getOptionLabel={getOptionLabel}
                isOptionEqualToValue={(option, val) =>
                    option?.value === val?.value
                }
                renderOption={(props, option, { selected }) => (
                    <li {...props}
                        style={{
                            alignItems: "center",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                        }} >
                        <Checkbox
                            checked={selected}
                            sx={{
                                mr: 1,
                                color: "#bb1ccc",
                                "&.Mui-checked": {
                                    color: "#bb1ccc",
                                },
                            }}
                        />
                        <div>{getOptionLabel(option)}</div>
                    </li>
                )}

                renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder={placeholder || "Select"}
                        size="small"
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                height: "35px",
                                borderRadius: "8px",

                                "& fieldset": {
                                    borderColor: "#d1d5db", // default gray
                                },

                                "&:hover fieldset": {
                                    borderColor: "#bb1ccc", // hover blue
                                },

                                "&.Mui-focused fieldset": {
                                    borderColor: "#bb1ccc", // focus blue
                                    borderWidth: "2px",
                                },
                            },
                        }}
                    />
                )}

            />
        </div>
    );
};

export default SingleSelect;
